export default __webpack_public_path__ + "static/media/foodbank_thumbnail.39d22f32.png";